<template>
  <div class="notfound-pag-container">
    <div class="back-info">
      <div class="content">
        您所寻找的页面不存在，你可以点击下面的按钮，返回主页
      </div>
      <el-button type="primary" class="custom-btn" @click="enterProjectList">
        返回首页
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    enterProjectList() {
      this.$router.push("./projectList");
    },
  },
};
</script>

<style lang="less">
.notfound-pag-container {
  position: relative;
  height: 100vh;
  background: url("../assets/img/404.jpeg") no-repeat center/cover;

  .back-info {
    position: absolute;
    top: 120px;
    right: 60px;
    width: 500px;
    text-align: left;
    font-size: 24px;

    .custom-btn {
      width: 150px;
      border-radius: 50px;
      color: var(--default-color);
      font-weight: bold;
    }

    .content {
      margin-bottom: 10px;
    }
  }
}
</style>